__turbopack_context__.v({
  "button": "AddProfileButton-module-scss-module__PsEIPq__button",
  "icon-inner": "AddProfileButton-module-scss-module__PsEIPq__icon-inner",
  "icon-outer": "AddProfileButton-module-scss-module__PsEIPq__icon-outer",
  "plus-icon": "AddProfileButton-module-scss-module__PsEIPq__plus-icon",
  "text": "AddProfileButton-module-scss-module__PsEIPq__text",
});
